import { requestWithToken } from '../utilities/request';
const path = '/api/private/spt';

const getSptLinkageSetting = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/fields/${fieldId}/spt_linkage_setting`,
  });
};

const getListSptFieldWorkTypes = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/fields/${fieldId}/spt_field_work_types/list`,
    params
  });
};

export const SptService = {
  getSptLinkageSetting,
  getListSptFieldWorkTypes,
};



// WEBPACK FOOTER //
// ./src/services/Spt.js